/**
 * 功能：按钮权限指令
 */
import type { Directive } from 'vue'
import { Cache, superRouter } from '@/tools'
import { type RouteLocationGeneric } from 'vue-router'
export const authOptsDirective: Directive = {
  mounted(el, { value }) {
    if (!value) return

    el.flag = false

    const currentRoute = superRouter.get().currentRoute.value

    if (!el.flag && !currentRoute.meta.menus) {
      const activeTab = Cache.ACTIVE_TAB.getItem<RouteLocationGeneric>()
      if (activeTab) {
        el.authOpts = activeTab.meta.menus?.authOpts || []
      }
      el.flag = true
    } else {
      el.authOpts = currentRoute.meta.menus?.authOpts || []
    }

    !el.authOpts.includes(value) && el.parentNode?.removeChild(el)
  },

  updated(el, { value }) {
    if (!value) return
    if (!el.authOpts?.includes(value)) {
      el.parentNode?.removeChild(el)
    } else {
      // 重新添加元素
      el.parentNode && el.parentNode.insertBefore(el, el.nextSibling)
    }
  },

  beforeUnmount(el) {
    el.currentRoute = null
    el.flag = null
  },
}
